import { Field, FieldProps, getIn } from 'formik';
import { ReactNode } from 'react';

import { CheckBox } from '../../components/Form';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { set } from 'common/utils/object-path';

interface ObjectCheckboxProps {
  name: string;
  label: ReactNode;
}

const ObjectCheckboxField = ({ name, label }: ObjectCheckboxProps) => (
  <Field name={name}>
    {({ field: { value }, form }: FieldProps) => {
      const handleChange = (e: CheckboxChangeEvent) => {
        const newValues = set(form.values, name, {
          checked: e.target.checked,
        });
        form.setValues(newValues);
      };

      const fieldError = getIn(form.errors, name);
      const error = typeof fieldError === 'string' ? fieldError : undefined;

      return <CheckBox checked={value?.checked} error={error} value={value} label={label} onChange={handleChange} />;
    }}
  </Field>
);

export default ObjectCheckboxField;
